import { render, staticRenderFns } from "./Collectionlimitcon.vue?vue&type=template&id=ef0be71a&scoped=true"
import script from "./Collectionlimitcon.vue?vue&type=script&lang=js"
export * from "./Collectionlimitcon.vue?vue&type=script&lang=js"
import style0 from "./Collectionlimitcon.vue?vue&type=style&index=0&id=ef0be71a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0be71a",
  null
  
)

export default component.exports